import { queryOptions } from '@tanstack/react-query';

import { fetchBroadcasters, fetchCompetitionBroadcastersCors } from '@apis/broadcasters';
import { uniqBy } from '@utilities/collection-utils';

export type BroadcastersParams = {
  startDate?: string;
  endDate?: string;
  competitionId?: string;
  roundId?: string;
  matchDayId?: string;
  countryCode?: string;
  regionCode?: string;
};
export type CompetitionBroadcastersParams = {
  countryCode: string;
  apiBaseUrl?: string;
};

export const getBroadcastersQuery = (options: BroadcastersParams) =>
  queryOptions({
    queryKey: ['broadcasters', options],
    queryFn: ({ signal }) => fetchBroadcasters({ ...options, limit: 500 }, signal),
    select: (result) => uniqBy(result?.flatMap((b) => b.broadcasters).filter((b) => !!b.name) ?? [], 'name'),
  });

export const getCompetitionBroadcastersQuery = (options: CompetitionBroadcastersParams) =>
  queryOptions({
    queryKey: ['comp-broadcasters', options],
    queryFn: ({ signal }) => fetchCompetitionBroadcastersCors({ ...options }, signal),
  });
